;(function($, undefined) {

    /*
        track specific events with omniture. omniture creates a global 's' object
        for us to use. For easy testing, make sure to load up this bookmarklet:
        https://helpx.adobe.com/analytics/using/digitalpulse-debugger.html
    */

    'use strict';

    var log = rnn.logging.log;

    function initOmniture() {
        log('[rnn] [modules] running omniture event tracking');
        
        omnitureURLCheck();

        if (!!$('[data-omniture-tracking]').length === true) { 
            trackOmniture();
        }
    }

    function setupTrackEvents() {
        // set default static fields
        s.linkTrackVars = 'events,eVar5,eVar6,eVar7,eVar11,eVar12,eVar13,prop3,prop8,prop36,prop37,products';
        s.linkTrackEvents = 'event37,event38,event27,event28,event216,prodView,scView,scCheckout,purchase';
    }

    function getChargifyProduct() {
        var chargifyCookie = rnn.modules.chargify.getChargifyCookieParams(),
            chargifyProduct = '';

        if (chargifyCookie && chargifyCookie.product_handle) {
            chargifyProduct = chargifyCookie.product_handle;
        }

        return chargifyProduct;
    }

    function getOmCookie(cookieName) {
        return Cookies.get(cookieName) || '';
    }

    function setProps($omData) {
        var sEvent = $omData.event || '',
            sProducts = '';

        switch(sEvent) {
            case 'scView':
            case 'scCheckout':
                sProducts = $omData.products;
                break;
            case 'purchase':
                sProducts = getChargifyProduct();
                break;
        }

        s.eVar5 = getOmCookie('omVar5');
        s.eVar6 = getOmCookie('omVar6');
        s.eVar7 = getOmCookie('omVar7');
        s.events = sEvent;
        if (sProducts && sProducts.length > 0) {
            sProducts = ';' + sProducts.split(',').join(',;');
        }
        s.products = sProducts;
    }

    function executeOmnitureTrack(name='subscriptions') {
        s.tl(this, 'o',  name);
    }

    function trackOmniture() {

        setupTrackEvents();

        $('[data-omniture-tracking]').each(function() {
            var $this = $(this),
                $omData = $this.data('omniture-tracking');

            if ($omData.pageView === true) {
                setProps($omData);
                executeOmnitureTrack();
            }
            if ($omData.clickTrack) {
                $this.on('click', function () {
                    if ($omData.eVar && $omData.event) {
                        s.events = $omData.event;
                        s[$omData.eVar] = $omData.value || '';
                        executeOmnitureTrack('click');
                    } else {
                        $omData.products = $(this).data('product-handle');
                        setProps($omData);
                        executeOmnitureTrack();
                    }

                });
            }
            if ($omData.clickStoreEvar) {
                $this.on('click', function (e) {
                   sessionStorage.setItem($omData.eVar, $omData.value);
                });
            }
        });
    }

    // used for things like modals that pop up on their own accord
    function trackCustomOmnitureEvent(eventID, eVar) {

        setupTrackEvents();

        s.events = eventID;
        s.eVar5 = eVar;

        // create a session cookie to use on other view pages.
        Cookies.set('omVar5', eVar);

        executeOmnitureTrack();
    }

    /*
    Check if the current url contains a needle string and if so 
    returns a value from the end of the url
    */
    function omnitureURLValue(needle) {
        var path = location.href.replace(location.search, ''),
            value = '';

        if (path.indexOf(needle) > -1) {
            var pathArray = path.split(needle);

            if (pathArray.length > 0) {
                // get the last value in the array
                value = pathArray.pop();
                // trim the last slash
                value = value.replace(/\/$/, '');
            }
        } else {
            // url doesnt contain the needle
            value = false;
        }
        return value;
    }

    function omnitureURLCheck() {
        var check = { 
            '/subscriptions/offer/': { 'cookie': 'omVar6', 'default': 'default' },
            '/subscriptions/sales/': { 'cookie': 'omVar7', 'default': '' }
        };

        _.each(check, function (obj, key) {
            var value = omnitureURLValue(key);
            if (value !== false) {
                if (value === '') {
                    value = obj.default;
                }
                Cookies.set(obj.cookie, value);
            }
        });

    }

    rnn.modules.register("omniture", {
        init: initOmniture,
        trackOmniture: trackOmniture,
        trackCustomOmnitureEvent: trackCustomOmnitureEvent
    });


})(jQuery);